import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RestrictionCriteria, RestrictionDTO, RestrictionOperator } from '@iota/iota-management-portal-v4-client';
import { GenderDescriptions, Genders } from '../../constants-and-enums/gender';
import { RestrictionCriteriaDescriptions, RestrictionCriterias } from '../../constants-and-enums/restriction-criteria';
import { RestrictionOperatorDescriptions, RestrictionOperators } from '../../constants-and-enums/restriction-operators';

@Component({
    standalone: false,
    selector: 'app-restriction',
    templateUrl: './restriction.component.html',
    styleUrls: ['./restriction.component.scss']
})
export class RestrictionComponent {
    @Input() restriction: RestrictionDTO;
    @Input() editMode = false;

    @Output() delete: EventEmitter<RestrictionDTO> = new EventEmitter<RestrictionDTO>();
    @Output() save: EventEmitter<RestrictionDTO> = new EventEmitter<RestrictionDTO>();

    criterias = RestrictionCriterias;
    operators = RestrictionOperators;
    genders = Genders;

    get operator(): string {
        return RestrictionOperatorDescriptions.get(this.restriction.operator);
    }

    onDelete() {
        this.delete.emit(this.restriction);
    }

    onSave() {
        this.save.emit(this.restriction);
    }

    getOperatorDescription(operator: RestrictionOperator): string {
        return RestrictionOperatorDescriptions.get(operator);
    }

    getCriteriaDescription(criteria: RestrictionCriteria): string {
        return RestrictionCriteriaDescriptions.get(criteria);
    }

    getGenderDescription(gender: string) {
        return GenderDescriptions.get(gender);
    }

    getAllowedOperators(restriction: RestrictionDTO): RestrictionOperator[] {
        if (restriction.criteria === RestrictionCriteria.GENDER) {
            const allowedOperators = [RestrictionOperator.EQ];
            if (!allowedOperators.includes(restriction.operator)) {
                restriction.operator = RestrictionOperator.EQ;
            }

            return allowedOperators;
        }

        return this.operators;
    }
}
